import { render, staticRenderFns } from "./ClienteOpere.vue?vue&type=template&id=4831ee82"
import script from "./ClienteOpere.vue?vue&type=script&lang=js"
export * from "./ClienteOpere.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports